import React from 'react';
import { Link } from 'react-router-dom';
import CSSModules from 'react-css-modules';
import { CROWDFUNDING_BASE_URI } from 'config';
import styles from './CrossSellBanner.scss';

interface Props {
  createPageLikeThis: () => void;
  crossSellBannerImpression: () => void;
}

class CrossSellBanner extends React.Component<Props> {
  componentDidMount() {
    this.props.crossSellBannerImpression();
  }

  render() {
    return (
      <section styleName="container">
        <h1 className="jg-h4 jg-space-mbmd">Great people make things happen</h1>
        <p className="jg-text">
          Do you know anyone in need or maybe want to help a local community
          cause?
        </p>
        <p className="jg-text jg-space-mbmd">
          Create you own page and donʼt let that cause go unfunded!
        </p>
        <div styleName="white">
          <a
            href={`${CROWDFUNDING_BASE_URI}/create`}
            className="jg-btn jg-btn--brand"
            styleName="action-create "
            onClick={this.props.createPageLikeThis}
          >
            Start a new Page
          </a>
        </div>
        <Link to={'/'} styleName="action-about">
          About Crowdfunding
        </Link>
      </section>
    );
  }
}

export default CSSModules(CrossSellBanner, styles);



// WEBPACK FOOTER //
// ./src/components/CrossSellBanner/CrossSellBanner.tsx